/* eslint-disable react/prop-types */
import axios from 'axios';
import React from 'react';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import JSEditProfileForm from '../JSEditProfileForm';
// helpers
import { logOutIfTokenExpired, resultInfo } from '../../helpers';

const ApplyJobCreateResumeForm = ({
  step,
  setStep,
  faculties,
  directories,
  profileBody,
  setFaculties,
}) => {
  const navigate = useNavigate();
  const userId = Cookies.get('user_id');
  const { t } = useTranslation('global');
  const tokenKey = Cookies.get('tokenClient');

  const handleCreate = async values => {
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: t('jobseekerEditProfile.no'),
        confirmButtonText: t('jobseekerEditProfile.yes'),
        title: t('jobseekerEditProfile.createConfirmTitle'),
      });

      if (confirmationResult.isConfirmed) {
        await axios.post(
          BaseApi + '/candidates/editProfile',
          values,
          {
            headers: {
              key: ApiKey,
              token: tokenKey,
              'Content-Type': 'application/json',
            },
          },
        );

        const response = await axios.post(
          BaseApi + '/candidates/createCvFromProfile',
          null,
          {
            headers: {
              key: ApiKey,
              token: tokenKey,
              'Content-Type': 'application/json',
            },
          },
        );

        if (response.data.status === 200) {
          setStep('jobApplySelect');

          resultInfo('success', t('jobseekerEditProfile.createSuccessTitle'), t('jobseekerEditProfile.close'));
        } else if (response.data.status === 400) {
          navigate('/');

          Cookies.remove('fname');
          Cookies.remove('user_id');
          Cookies.remove('user_type');
          Cookies.remove('tokenClient');

          resultInfo('warning', response.data.message, t('jobseekerEditProfile.close'));
        } else {
          resultInfo('error', response.data.message, t('jobseekerEditProfile.close'));
        }
      }
    } catch (error) {
      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      } else {
        resultInfo('error', t('jobseekerEditProfile.createFailedTitle'), t('jobseekerEditProfile.close'));
      }

      console.error('Could not submit edit data!', error);
    }
  };

  return(
    <JSEditProfileForm
      isCopy
      id={userId}
      step={step}
      setStep={setStep}
      faculties={faculties}
      directories={directories}
      profileBody={profileBody}
      handleCreate={handleCreate}
      setFaculties={setFaculties}
    />
  );
};

export default ApplyJobCreateResumeForm;
